;(function () {
    function BackgroundImage(images) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            images.each(function (key, element) {
                $image = $(element)
                $image.css('background-image', 'url(' + $image.data().backgroundImage + ')')
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Creaton = window.Creaton || {}

    window.Creaton.BackgroundImage = BackgroundImage
})()

$(document).ready(function () {
    var images = $('[data-background-image]')

    if (images.length > 0) {
        new window.Creaton.BackgroundImage(images)
    }
})
